import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/header.css';
import PlayerBalance from './playerBalance';
import {DateTime} from './dateTime';
import {OPERATOR} from './../../../constants/operator';
import { LOBBY_BUTTON_LEFT, LOBBY_BUTTON_RIGHT } from '../../../constants/identifiers';

const mapStateToProps = (state, ownProps) => {
    return {
        showHeader: state.vpp.showHeader,
        showCloseButton: state.vpp.showCloseButton,
        serverTimeOffset: state.vpp.serverTimeOffset,
        serverTimeZoneOffset: state.vpp.serverTimeZoneOffset,
        showCloseButtonPosition: state.vpp.showCloseButtonPosition,
    };
};

class Header extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            showHeader: storeData.vpp.showHeader,
            showCloseButton: storeData.vpp.showCloseButton,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            serverTimeZoneOffset: storeData.vpp.serverTimeZoneOffset,
            showCloseButtonPosition: storeData.vpp.showCloseButtonPosition,
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                showHeader: storeData.vpp.showHeader,
                showCloseButton: storeData.vpp.showCloseButton,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
                serverTimeZoneOffset: storeData.vpp.serverTimeZoneOffset,
                showCloseButtonPosition: storeData.vpp.showCloseButtonPosition,
            });
        }
    }

    render() {
        let header = '';
        if (this.state.showHeader) {
            let showHeaderDateFormat = OPERATOR.header.dateFormat;
            const components = {
                time: <DateTime
                    timeOffset={this.state.serverTimeOffset}
                    timeZoneOffset={this.state.serverTimeZoneOffset}
                    store={this.props.store}
                    showHeaderDateFormat={showHeaderDateFormat}/>,
                balance: <PlayerBalance store={this.props.store}/>,
            }
            let lobbyButtonLeft = '';
            let lobbyButtonRight = '';

            // eslint-disable-next-line no-undef
            if (process.env.NODE_ENV !== 'development' && this.state.showCloseButton && BMS.mayGoHome) {
                // eslint-disable-next-line no-undef
                lobbyButtonLeft = (LOBBY_BUTTON_LEFT === this.state.showCloseButtonPosition ? (<div className={style.close} onClick={() => BMS.goHome()}/>) : '');
                // eslint-disable-next-line no-undef
                lobbyButtonRight = (LOBBY_BUTTON_RIGHT === this.state.showCloseButtonPosition ? (<div className={style.close} onClick={() => BMS.goHome()}/>) : '');
            }

            let leftContent = components[OPERATOR.header.left]
            let centreContent = components[OPERATOR.header.centre]
            let rightContent = components[OPERATOR.header.right]

            header = (<div className={style.header} ref={this.props.reference}>
                {lobbyButtonLeft}
                <div className={style.left}> {leftContent} </div>
                <div className={style.center}> {centreContent} </div>
                <div className={style.right}> {rightContent} </div>
                {lobbyButtonRight}
            </div>);

        }
        return header;
    }

}

export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/header.js